<template>
  <b-modal
    :ref="modalKey"
    hide-footer
    centered
    :title="title"
    @shown="modalShown"
    @hidden="modalHidden"
  >
    <b-form @submit.prevent="save">
      <b-form-group
        class="dg-onChangeHandlerCode"
      >
        <codemirror
          v-if="shown"
          :value="code || ''"
          :options="cmOptions"
          @input="onCmCodeChange"
          @keydown.ctrl.83.native.prevent="save"
        />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// service
import db from '@/services/db'

export default {
  props: ['widgetKey', 'gridId', 'options'],
  data () {
    return {
      shown: false,
      code: null,
      cmOptions: {
        tabSize: 2,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter'
        ],
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
        hintOptions: {
          completeSingle: false
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        extraKeys: {
          'Ctrl': 'autocomplete'
        },
        mode: 'text/javascript'
      },
      modalKey: 'onChangeHandlerModal',
      cellKey: null
    }
  },
  computed: {
    title () {
      if (!this.cellKey) return null

      return `On change event handler for column "${this.options.meta[this.cellKey].displayName}"`
    }
  },
  methods: {
    modalShown () {
      this.shown = true
    },
    modalHidden () {
      this.shown = false
    },
    onCmCodeChange (code) {
      this.code = code
    },
    save () {
      const meta = Object.assign({}, this.options.meta)

      meta[this.cellKey].onChange = this.code

      const data = {
        gridId: this.gridId,
        oName: 'meta',
        oValue: meta
      }

      db.dataGrid.options.saveOption(data, () => {
        this.$refs[this.modalKey].hide()
      })
    }
  },
  created () {
    eventBus.$on(`showOnChangeHandlerModal${this.widgetKey}-${this.gridId}`, (cellKey) => {
      this.cellKey = cellKey
      this.code = null

      if (this.options.meta && this.options.meta[cellKey]) {
        const code = this.options.meta[cellKey].onChange

        if (code) this.code = code
      }

      if (this.$refs[this.modalKey]) {
        this.$refs[this.modalKey].show()
      }
    })
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.dg-onChangeHandlerCode {
  height: 25vh;
  border: 1px solid $borderColor1;
  > div,
  .vue-codemirror,
  .CodeMirror {
    height: 100%;
  }
}
</style>

